import { IHistoryService } from '@/modules/canvas/services/history/IHistoryService';
import { HistoryServiceImpl } from '@/modules/canvas/services/history/HistoryServiceImpl';
import { useHistoryStore } from '@/modules/history/useHistoryStore';

export class HistoryServiceFactory {
  private static instance: HistoryServiceFactory | null = null;
  private historyStore: typeof useHistoryStore;
  private historyService: IHistoryService | null = null;

  public static initialize(historyStore: typeof useHistoryStore) {
    HistoryServiceFactory.instance = new HistoryServiceFactory(historyStore);
  }

  public static getInstance() {
    if (HistoryServiceFactory.instance === null) {
      throw new Error(
        'HistoryServiceFactory not yet initialized. Call HistoryServiceFactory.initialize() first.',
      );
    }
    return HistoryServiceFactory.instance;
  }

  private constructor(historyStore: typeof useHistoryStore) {
    this.historyStore = historyStore;
  }

  public createHistoryService(): IHistoryService {
    if (!this.historyService) {
      this.historyService = new HistoryServiceImpl(this.historyStore);
    }
    return this.historyService;
  }
}
